<template>
  <div class="checkbox-tree__component">
    <div
      v-for="item, index in items"
      class="checkbox-tree__item"
      :key="item.id"
      :class="{
       'checkbox-tree__item_open': (openedSubLvls.indexOf(item.id) > -1 && item.childs.length > 0)
    }"
    >
      <div class="checkbox-tree__item-container">
        <div
          v-if="item.childs.length > 0"
          class="checkbox-tree__arrow"
          @click.stop.prevent="toggleItem(item)"
        ></div>
        <div
          v-else
          class="checkbox-tree__offset"
        ></div>
        <label class="checkbox-label">
          <input
            type="checkbox"
            class="checkbox-input"
            v-model="valuesModel.vals"
            :value="item.id"
            @change.stop.prevent="onChange(item)"
            :disabled="disabled"
          >
          <div
            class="checkbox-icon"
            :class="{
               'checkbox-icon__disabled': disabled,
               'checkbox-icon_group': item.isPartialSelect
            }"
          ></div>
          <div class="checkbox-text">{{item.name}}</div>
        </label>
      </div>

      <e-select-nested-list-item
        class="checkbox-tree__item_open"
        v-if="openedSubLvls.indexOf(item.id) > -1 && item.childs.length > 0"
        :key="item.id"
        :items="item.childs"
        :parent="item"
        :lvl="(lvl + 1)"
        :valuesModel="valuesModel"
        :disabled="disabled"
        @change="$emit('change', $event)"
        @collapse="$emit('collapse', $event)"
        @expand="$emit('expand', $event)"
      ></e-select-nested-list-item>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'e-select-nested-list-item',
    data () {
      return {
        openedSubLvls: []
      }
    },
    props: {
      items: {
        type: Array,
        default: function () {
          return []
        }
      },
      parent: {
        type: Object
      },
      lvl: {
        type: Number,
        default: 0
      },
      onCreateExpandToLvl: {
        type: Number,
        default: 1
      },
      valuesModel: {
        type: Object,
        required: true,
        default: function () {
          return {
            vals: []
          }
        }
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      selectAllChilds (item) {
        const newValues = []
        const oldValues = this.valuesModel.vals.slice()
        item.childsIdArr.forEach(id => {
          if (oldValues.indexOf(id) === -1) {
            newValues.push(id)
          }
        })
        this.valuesModel.vals = [
          ...newValues,
          ...oldValues
        ]
      },
      unselectAllChilds (item) {
        let oldValues = this.valuesModel.vals.slice()
        item.childsIdArr.forEach(id => {
          oldValues = oldValues.filter(v => v !== id)
        })
        this.valuesModel.vals = oldValues
      },
      onChange (item) {
        if (this.valuesModel.vals.indexOf(item.id) === -1) {
          this.unselectAllChilds(item)
        } else {
          this.selectAllChilds(item)
        }
        this.checkSelection()
        this.$emit('change', item)
      },
      checkSelection () {
        if (!this.parent) {
          return
        }
        let len = this.items.length
        let allSelected = this.valuesModel.vals.length > 0
        for (let i = 0; i < len; i++) {
          if (this.valuesModel.vals.indexOf(this.items[i].id) === -1) {
            allSelected = false
            break
          }
        }
        if (allSelected === true) {
          // select parent
          if (this.valuesModel.vals.indexOf(this.parent.id) === -1) {
            this.valuesModel.vals.push(this.parent.id)
          }
        } else if (this.valuesModel.vals.indexOf(this.parent.id) > -1) {
          // unselect parent
          this.valuesModel.vals = this.valuesModel.vals.filter(id => id !== this.parent.id)
        }
        if (this.$parent.checkSelection) {
          this.$parent.checkSelection()
        }
      },
      toggleItem (item) {
        if (this.openedSubLvls.indexOf(item.id) === -1) {
          this.expandItem(item)
        } else {
          this.collapseItem(item)
        }
      },
      collapseItem (item) {
        if (item.childs.length > 0) {
          this.openedSubLvls = this.openedSubLvls.filter(v => v.id === item.id)
        }
        this.$emit('collapse')
      },
      expandItem (item) {
        if (item.childs.length > 0) {
          this.openedSubLvls.push(item.id)
        }
        this.$emit('expand')
      },
      expandAll () {
        this.items.forEach(item => {
          this.expandItem(item)
        })
      }
    },
    created () {
      if (this.lvl < this.onCreateExpandToLvl) {
        this.expandAll()
      }
    }
  }
</script>
